import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { useCareSuggestPatientMutation } from '@/entities/care-patients';

import { useRequestsCompletionPrompt } from '../model/useRequestsCompletionPrompt';
import { RequestsCompletionDialog } from './RequestsCompletionDialog';

export function RequestsCompletionPrompt() {
  const navigate = useNavigate();
  const { patientUserId, shouldShowPrompt } = useRequestsCompletionPrompt();
  const suggestPatientMutation = useCareSuggestPatientMutation();

  const [trackedPatient, setTrackedPatient] = useState(patientUserId);
  const [dismissed, setDismissed] = useState(false);
  const [nextPatientName, setNextPatientName] = useState<string | null | undefined>(undefined);

  // Reset on patient change
  if (trackedPatient !== patientUserId) {
    setTrackedPatient(patientUserId);
    setDismissed(false);
    setNextPatientName(undefined);
  }

  const shouldShowDialog = shouldShowPrompt && !dismissed;

  const handleDismiss = () => {
    setDismissed(true);
    setNextPatientName(undefined);
  };

  const handleSuggestAndNavigate = async () => {
    if (suggestPatientMutation.isPending) {
      return;
    }

    const response = await suggestPatientMutation.mutateAsync();
    const suggestedPatient = response.patient;

    if (suggestedPatient === null) {
      setNextPatientName(null);
      toast.success("You're all caught up!");
      return;
    }

    handleDismiss();
    navigate(`/patient/${suggestedPatient.user_id}`);
  };

  return (
    <RequestsCompletionDialog
      open={shouldShowDialog}
      onOpenChange={(nextOpen) => {
        if (suggestPatientMutation.isPending) {
          return;
        }
        if (!nextOpen) {
          handleDismiss();
        }
      }}
      patientName="this patient"
      nextPatientName={nextPatientName}
      isSuggesting={suggestPatientMutation.isPending}
      onStay={handleDismiss}
      onGoToNextPatient={() => void handleSuggestAndNavigate()}
    />
  );
}
